// extracted by mini-css-extract-plugin
export var partners = "Partners--partners--TmOIi";
export var partners__logo = "Partners--partners__logo--Gs-4D";
export var partners__partner = "Partners--partners__partner--soDgF";
export var tkMyriadProSemiCondensed = "Partners--tk-myriad-pro-semi-condensed--UR54o";